import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';

export interface TabData {
    menuItem: string;
    render: () => React.ReactNode;
}

interface Props {
    tabs: TabData[];
}

export default function TabContainer({ tabs }: Props) {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ mb: 2 }}
            >
                {tabs.map((tab, idx) => (
                    <Tab key={idx} label={tab.menuItem} />
                ))}
            </Tabs>
            <Box sx={{ p: 2 }}>
                {tabs[activeTab]?.render()}
            </Box>
        </Box>
    );
}